import { NAMES_ROUTES } from "@/const/routes.constants"

const { ROOT, WAREHOUSE } = NAMES_ROUTES.REPORTS

export const FREQUENCY = {
  ONCE: "once",
  REPEATING: "repeating"
} as const

export const REPORT_TAB_PARAM = "reportTabParam"

export const DEFAULT_ROUTE = `/${ROOT}/${WAREHOUSE}`
